// Mock data for category cards
const categoryData = {
  marketCap: {
    id: "market-cap",
    title: "Top Market Cap Coins",
    description:
      "Watch the highest market cap coins go head-to-head in a thrilling race!",
    gradient: "gradient-market-cap",
    icons: ["₿", "Ξ", "✗"],
    type: "marketCap",
    stats: {
      totalPools: 12,
      activeRaces: 4,
      totalVolume: 125000,
    },
    timer: { hours: "01", minutes: "59", seconds: "59" },
  },
  altcoin: {
    id: "alt-coins",
    title: "Top Alt Coins",
    description:
      "Join a race featuring the best-performing altcoins in the market!",
    gradient: "gradient-alt-coins",
    icons: ["★"],
    type: "altcoin",
    stats: {
      totalPools: 8,
      activeRaces: 3,
      totalVolume: 75000,
    },
    timer: { hours: "00", minutes: "45", seconds: "30" },
  },
  meme: {
    id: "meme-coins",
    title: "Memecoins",
    description: "Epic races with the most viral and unpredictable meme coins!",
    gradient: "gradient-meme",
    icons: ["🐸"],
    type: "meme",
    stats: {
      totalPools: 6,
      activeRaces: 2,
      totalVolume: 50000,
    },
    timer: { hours: "02", minutes: "15", seconds: "00" },
  },
  defi: {
    id: "defi-tokens",
    title: "DeFi Tokens",
    description:
      "Compete with the top DeFi tokens in this decentralized finance race!",
    gradient: "gradient-defi",
    icons: ["🌿"],
    type: "defi",
    stats: {
      totalPools: 10,
      activeRaces: 3,
      totalVolume: 95000,
    },
    timer: { hours: "01", minutes: "30", seconds: "45" },
  },
};

// Simulate API delay
const simulateDelay = () => new Promise((resolve) => setTimeout(resolve, 500));

// Get all categories
export async function getAllCategories() {
  await simulateDelay();
  return Object.values(categoryData);
}

// Get category by type
export async function getCategoryByType(type) {
  await simulateDelay();
  return categoryData[type];
}

// Get category stats
export async function getCategoryStats(type) {
  await simulateDelay();
  return categoryData[type]?.stats || null;
}

// Get next race timer for category
export async function getCategoryTimer(type) {
  await simulateDelay();
  return categoryData[type]?.timer || null;
}

// Get total volume across all categories
export async function getTotalVolume() {
  await simulateDelay();
  return Object.values(categoryData).reduce(
    (total, category) => total + category.stats.totalVolume,
    0
  );
}

// Get total active races
export async function getTotalActiveRaces() {
  await simulateDelay();
  return Object.values(categoryData).reduce(
    (total, category) => total + category.stats.activeRaces,
    0
  );
}

// Update category timer (simulated real-time update)
export function updateCategoryTimer(type, newTimer) {
  if (categoryData[type]) {
    categoryData[type].timer = newTimer;
    return true;
  }
  return false;
}
